"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _range = _interopRequireDefault(require("lodash/range"));

var _find2 = _interopRequireDefault(require("lodash/find"));

var _chunk = _interopRequireDefault(require("lodash/chunk"));

var _findLast2 = _interopRequireDefault(require("lodash/findLast"));

var _parseISO = _interopRequireDefault(require("date-fns/parseISO"));

var _differenceInCalendarDays = _interopRequireDefault(require("date-fns/differenceInCalendarDays"));

var _calendar = _interopRequireDefault(require("@amzn/meridian-tokens/component/calendar"));

var _theme = require("../theme");

var _propTypes2 = _interopRequireDefault(require("./../_prop-types"));

var _parsers = require("./../_prop-types/parsers");

var _text = _interopRequireDefault(require("./../_styles/text"));

var _visuallyHidden = _interopRequireDefault(require("./../_styles/visually-hidden"));

var _dateString = require("./../_utils/date-string");

var _getCalendarMonth = _interopRequireDefault(require("./../_utils/get-calendar-month"));

var _dateLocales = _interopRequireDefault(require("./../_utils/date-locales"));

var _token = require("./../_utils/token");

var _organizeDistributedEvents = _interopRequireDefault(require("./../_utils/organize-distributed-events"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var dayMinWidth = 100;
var daysInWeek = 7; // Returns a function to determine if an event overlaps in any way the month.

var overlapsMonth = function overlapsMonth(days) {
  // Get the first/last dates that falls in the month
  var _find = (0, _find2["default"])(days, function (_ref) {
    var inMonth = _ref.inMonth;
    return inMonth;
  }),
      firstDayOfMonth = _find.dateString;

  var _findLast = (0, _findLast2["default"])(days, function (_ref2) {
    var inMonth = _ref2.inMonth;
    return inMonth;
  }),
      lastDayOfMonth = _findLast.dateString;

  return function (event) {
    return (0, _dateString.isWithinRange)(firstDayOfMonth, event.start, event.end) || (0, _dateString.isWithinRange)(event.start, firstDayOfMonth, lastDayOfMonth);
  };
};
/**
 * The grid here can get a little crazy as it's built of a column of grids.
 *
 * The header row is pretty straightforward grid of one row. The week rows, however, are
 * themselves a grid of 2+ rows depending on the number of distributed events.
 *
 * header row
 * ----
 *          [ day label row
 * week row | distributed event rows
 *          [ stacked events row
 * ------
 *          [ day label row
 * week row | distributed event rows
 *          [ stacked events row
 */
// Styles for the outer wrapper.


var styles = function styles(t) {
  return (0, _emotion.css)({
    overflowX: "auto",
    backgroundColor: t("dayBackgroundColor")
  });
}; // HACK: Grid column styles for IE11 because IE11 doesn't automatically assign
// row/column placement based on DOM placement - you have to manually set row
// and column numbers for each item.


var msWeekGridStyles = _objectSpread({
  display: "-ms-grid",
  msGridColumns: "(minmax(".concat(dayMinWidth, "px, 1fr))[").concat(daysInWeek, "]")
}, (0, _range["default"])(daysInWeek).reduce(function (gridItemStyles, index) {
  gridItemStyles["& > *:nth-of-type(".concat(index + 1, ")")] = {
    msGridColumn: index + 1
  };
  return gridItemStyles;
}, {}));

var weekHeaderStyles = function weekHeaderStyles(t) {
  var _span;

  return (0, _emotion.css)((0, _text["default"])(t), msWeekGridStyles, // HACK: CSS "grid" for IE11
  {
    position: "relative",
    display: "grid",
    gridTemplateColumns: "repeat(".concat(daysInWeek, ", minmax(").concat(dayMinWidth, "px, 1fr))"),
    gridGap: 0,
    color: t("foregroundColor"),
    "& > span": (_span = {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: t("dayOfWeekHeaderFontWeight"),
      height: t("dayOfWeekHeaderHeight"),
      boxSizing: "border-box",
      backgroundColor: t("backgroundColor"),
      borderColor: t("borderColor"),
      borderStyle: "solid",
      borderWidth: "".concat(t("dayOfWeekHeaderBorderWidth"), "px 0")
    }, (0, _defineProperty2["default"])(_span, "&:not(:first-of-type)", (0, _defineProperty2["default"])({
      borderLeftWidth: t("borderWidth")
    }, "[dir=\"rtl\"] &", {
      borderRightWidth: t("borderWidth"),
      borderLeftWidth: "0"
    })), (0, _defineProperty2["default"])(_span, "& [mdn-calendar-week-header-screenreader-label]", _visuallyHidden["default"]), _span),
    // Add header drop shadow styles as one large element. We add
    // as large element vs in each individual header so the shadow
    // doesn't overlap sibling neighbors on the x-axis.
    "&::after": {
      zIndex: 10,
      content: "\"\"",
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      minWidth: daysInWeek * dayMinWidth,
      height: t("dayOfWeekHeaderHeight"),
      pointerEvents: "none",
      boxShadow: t.boxShadowCss("dayOfWeekHeaderShadow")
    }
  });
};

var weekStyles = (0, _token.memoizeTokenStyles)(function (t, _ref3) {
  var maxDistributedRowCount = _ref3.maxDistributedRowCount,
      distributedEventSpacingVertical = _ref3.distributedEventSpacingVertical;
  return (0, _emotion.css)((0, _text["default"])(t), msWeekGridStyles, // HACK: CSS "grid" for IE11
  {
    display: "grid",
    gridTemplateColumns: "repeat(".concat(daysInWeek, ", minmax(").concat(dayMinWidth, "px, 1fr))"),
    gridGap: 0,
    position: "relative",
    // Add a bottom border to all weeks except ones in the last row
    "&:not(:last-child) > [role='cell']": {
      borderBottom: t.borderCss("border")
    },
    // Day headers
    "& > [mdn-calendar-date-header]": {
      gridRow: 1,
      msGridRow: 1,
      padding: "".concat(t("spacingInsetDay"), "px"),
      textAlign: "right",
      lineHeight: t("dayLabelLineHeight"),
      "&[mdn-calendar-date-header-outside-month]": {
        color: t("dayLabelOutsideRangeColor")
      },
      "&:not([mdn-calendar-date-header-outside-month])": {
        fontWeight: t("dayLabelInsideRangeWeight")
      },
      "&:not(:first-of-type)": (0, _defineProperty2["default"])({
        borderLeft: t.borderCss("border")
      }, "[dir=\"rtl\"] &", {
        borderRight: t.borderCss("border"),
        borderLeftWidth: "0"
      }),
      // Draw the current day indicator using a pseudo element
      "& > span": {
        position: "relative",
        "&[aria-current='date']:before": {
          content: "\"\"",
          position: "absolute",
          bottom: -t("currentHeadingIndicatorSpacingVertical") + t("currentHeadingIndicatorHeight"),
          transform: "translateX(-50%)",
          left: "50%",
          minWidth: "2ch",
          height: t("currentHeadingIndicatorHeight"),
          backgroundColor: t("currentHeadingIndicatorColor"),
          borderRadius: t("currentHeadingIndicatorBorderRadius")
        }
      }
    },
    // Stacked events
    "& > [role='cell']": {
      display: "block",
      gridRow: maxDistributedRowCount + 2,
      msGridRow: maxDistributedRowCount + 2,
      padding: "".concat(t("spacingInsetDay"), "px"),
      paddingTop: 0,
      "&:not([mdn-calendar-date-cell='first'])": (0, _defineProperty2["default"])({
        borderLeft: t.borderCss("border")
      }, "[dir=\"rtl\"] &", {
        borderRight: t.borderCss("border"),
        borderLeftWidth: "0"
      })
    },
    // Distributed events
    "& > [mdn-calendar-distributed-event]": {
      margin: "0 0 ".concat((0, _parsers.parseSpacing)(distributedEventSpacingVertical), "px 0"),
      "&:not([mdn-calendar-distributed-event-clip-start])": (0, _defineProperty2["default"])({
        paddingLeft: t("spacingInsetDay")
      }, "[dir=\"rtl\"] &", {
        paddingRight: t("spacingInsetDay"),
        paddingLeft: "0"
      }),
      "&:not([mdn-calendar-distributed-event-clip-end])": (0, _defineProperty2["default"])({
        paddingRight: t("spacingInsetDay")
      }, "[dir=\"rtl\"] &", {
        paddingLeft: t("spacingInsetDay"),
        paddingRight: "0"
      })
    }
  });
}, ["maxDistributedRowCount", "distributedEventSpacingVertical"]);

var distributedEventStyles = function distributedEventStyles(_ref4) {
  var row = _ref4.row,
      startDate = _ref4.startDate,
      endDate = _ref4.endDate,
      firstDateOfWeek = _ref4.firstDateOfWeek;
  var startColumn = (0, _differenceInCalendarDays["default"])((0, _parseISO["default"])(startDate), firstDateOfWeek) + 1;
  var endColumn = (0, _differenceInCalendarDays["default"])((0, _parseISO["default"])(endDate), firstDateOfWeek) + 1;
  return (0, _emotion.css)({
    gridRow: row + 2,
    gridColumn: "".concat(startColumn, " / ").concat(endColumn + 1),
    // HACK: CSS "grid" for IE11
    msGridRow: row + 2,
    msGridColumn: "".concat(startColumn),
    msGridColumnSpan: endColumn - startColumn + 1
  });
};

var distributedEventGridStyles = (0, _token.memoizeTokenStyles)(function (t, _ref5) {
  var maxDistributedRowCount = _ref5.maxDistributedRowCount;
  return (0, _emotion.css)(msWeekGridStyles, // HACK: CSS "grid" for IE11
  {
    msGridRows: "100%",
    msGridColumn: 1,
    msGridColumnSpan: daysInWeek,
    msGridRow: 2,
    msGridRowSpan: maxDistributedRowCount
  }, {
    position: "absolute",
    width: "100%",
    height: "100%",
    gridColumn: 1,
    gridColumnSpan: daysInWeek,
    gridRow: 2,
    gridRowSpan: maxDistributedRowCount,
    display: "grid",
    gridTemplateColumns: "repeat(".concat(daysInWeek, ", minmax(").concat(dayMinWidth, "px, 1fr))"),
    "& > div:not(:first-of-type)": (0, _defineProperty2["default"])({
      borderLeft: t.borderCss("border")
    }, "[dir=\"rtl\"] &", {
      borderRight: t.borderCss("border"),
      borderLeftWidth: "0"
    })
  });
}, ["maxDistributedRowCount"]);
/**
 * This component renders a single calendar month.
 *
 * @since 5.x
 */

var CalendarMonthView = function CalendarMonthView(props) {
  var t = (0, _theme.useTheme)(_calendar["default"], "calendar");
  var now = (0, _react.useMemo)(function () {
    return (0, _dateString.toDateString)((0, _parseISO["default"])(props.now));
  }, [props.now]);

  var _useMemo = (0, _react.useMemo)(function () {
    return (0, _getCalendarMonth["default"])({
      date: props.viewDate,
      locale: props.locale,
      headerLabelFormat: props.headerDateFormat
    });
  }, [props.viewDate, props.locale, props.headerDateFormat]),
      days = _useMemo.days,
      dayOfWeekLabels = _useMemo.dayOfWeekLabels;

  var weeks = (0, _react.useMemo)(function () {
    return (0, _chunk["default"])(days, daysInWeek);
  }, [days]); // If distributed events were passed, we chunk them here into their respective weeks and
  // determine the optimal row so as few overlap as possible. Events that span multiple weeks
  // are duplicated into each week they overlap.

  var distributedEvents = (0, _react.useMemo)(function () {
    if (props.distributedEvents) {
      // Determine the first and last days of each week on the calendar.
      var firstDaysOfEachWeek = days.filter(function (_, index) {
        return index % daysInWeek === 0;
      });
      var lastDaysOfEachWeek = days.slice(daysInWeek - 1).filter(function (_, index) {
        return index % daysInWeek === 0;
      }); // All distributed events that overlap the month in some way.

      var distributedEventsInMonth = props.distributedEvents.filter(overlapsMonth(days));
      return (0, _range["default"])(firstDaysOfEachWeek.length).map(function (week) {
        return (0, _organizeDistributedEvents["default"])({
          distributedEvents: distributedEventsInMonth,
          timeRangeStart: "".concat(firstDaysOfEachWeek[week].dateString, " 00:00"),
          timeRangeEnd: "".concat(lastDaysOfEachWeek[week].dateString, " 24:00")
        });
      });
    } else {
      return [];
    }
  }, [props.distributedEvents, days]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles(t),
    role: "table"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: weekHeaderStyles(t),
    role: "row"
  }, dayOfWeekLabels.map(function (_ref6) {
    var label = _ref6.label,
        _long = _ref6["long"],
        weekday = _ref6.weekday;
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: _long,
      role: "columnheader"
    }, props.renderHeader ? /*#__PURE__*/_react["default"].createElement(props.renderHeader, {
      weekday: weekday,
      label: label
    }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
      "aria-hidden": "true",
      title: _long
    }, label), /*#__PURE__*/_react["default"].createElement("span", {
      "mdn-calendar-week-header-screenreader-label": ""
    }, _long)));
  })), weeks.map(function (week, weekIndex) {
    var weekDistributedEvents = distributedEvents[weekIndex] || [];
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: weekStyles(t, {
        maxDistributedRowCount: weekDistributedEvents.length,
        distributedEventSpacingVertical: props.distributedEventSpacingVertical
      }),
      key: weekIndex,
      role: "row"
    }, week.map(function (_ref7, index) {
      var dateString = _ref7.dateString,
          label = _ref7.label,
          _long2 = _ref7["long"],
          inMonth = _ref7.inMonth;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: dateString
      }, /*#__PURE__*/_react["default"].createElement("div", {
        "mdn-calendar-date-header": "",
        "mdn-calendar-date-header-outside-month": !inMonth ? "" : undefined,
        "aria-hidden": "true"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        "aria-current": dateString === now && props.showNow ? "date" : undefined
      }, label)), /*#__PURE__*/_react["default"].createElement("div", {
        role: "cell",
        "mdn-calendar-date-cell": index === 0 ? "first" : undefined
      }, /*#__PURE__*/_react["default"].createElement("div", {
        role: "group",
        "aria-label": _long2
      }, !props.renderDay ? null : /*#__PURE__*/_react["default"].createElement(props.renderDay, {
        date: dateString
      }))));
    }), weekDistributedEvents.length ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      "aria-hidden": true,
      className: distributedEventGridStyles(t, {
        maxDistributedRowCount: weekDistributedEvents.length
      })
    }, (0, _range["default"])(0, daysInWeek).map(function (day) {
      return (
        /*#__PURE__*/
        // HACK: non-breaking space needed for IE11 to render div in grid
        _react["default"].createElement("div", {
          key: day
        }, "\xA0")
      );
    })), weekDistributedEvents.map(function (event, index) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        "mdn-calendar-distributed-event": "",
        "mdn-calendar-distributed-event-clip-end": event.clipEnd ? "" : undefined,
        "mdn-calendar-distributed-event-clip-start": event.clipStart ? "" : undefined,
        className: distributedEventStyles({
          row: event.row,
          startDate: event.startDate,
          endDate: event.endDate,
          firstDateOfWeek: week[0].dateObject
        }),
        key: index
      }, /*#__PURE__*/_react["default"].createElement(event.render, {
        start: event.start,
        startDate: event.startDate,
        end: event.end,
        endDate: event.endDate,
        render: event.render,
        row: event.row,
        clipStart: event.clipStart,
        clipEnd: event.clipEnd,
        locale: props.locale,
        // TODO: 6.x remove clipLeft/Right
        clipRight: event.clipRight,
        clipLeft: event.clipLeft
      }));
    })) : null);
  }));
};

CalendarMonthView.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * This date is used to determine which month the calendar should display.
   * The date must be provided in an ISO 8601 format (e.g. YYYY-MM-DD).
   *
   * Read more about [ISO 8601 format](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/parse#Date_Time_String_Format).
   */
  viewDate: _propTypes["default"].string.isRequired,

  /**
   * Sets vertical spacing between distributed events.
   */
  distributedEventSpacingVertical: _propTypes2["default"].spacing(1),

  /**
   * Distributed events are stretched across day columns according to their start/end
   * days above stacked events. Each event requires a start/end date time string in
   * an ISO 8601 format (e.g. YYYY-MM-DD HH:mm) and a component to render.
   *
   * The component will be rendered with the original `start`/`end` values as props,
   * the `locale` prop, and `clipStart` and `clipEnd` Boolean props that will be true if
   * the event exceeds the start or end time ranges (__NOTE__: `clipLeft` and `clipRight`
   * are now deprecated and will be removed in 6.x).
   *
   * The component will render inside a container that spans from the start to end days.
   * Be sure that the rendered component fills up it's containers width.
   *
   * Read more about [ISO 8601 format](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/parse#Date_Time_String_Format).
   */
  distributedEvents: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    start: _propTypes["default"].string.isRequired,
    end: _propTypes["default"].string.isRequired,
    render: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]).isRequired
  })),

  /**
   * The format of the time in the headers. See [Intl.DateTimeFormat](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat) for available values.
   *
   * NOTE: This cannot be changed after the component is mounted.
   */
  headerDateFormat: _propTypes["default"].object,

  /**
   * The locale to use when rendering the input (e.g. month names, names of
   * days of the week, etc.). See the [Intl API](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl)
   * for more information about date internationalization in JS.
   */
  locale: _propTypes["default"].oneOf(Object.keys(_dateLocales["default"])),

  /**
   * Define current date in an ISO 8601 format (e.g. YYYY-MM-DD). This date will be
   * marked in the calendar with a special indicator.
   *
   * Read more about [ISO 8601 format](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/parse#Date_Time_String_Format).
   */
  now: _propTypes["default"].string,

  /**
   * A component that can render the contents of an individual day. The
   * component will be rendered with a single `date` prop containing the day's
   * date as a string (YYYY-MM-DD).
   */
  renderDay: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),

  /**
   * A component that renders the days of the week for the month. The
   * component will be rendered with a `label` prop formatted to
   * the calendar's locale as well as a `weekday` prop that will be
   * one of the following irrespective of locale: "sunday", "monday",
   * "tuesday", "wednesday", "thursday", "friday", "saturday".
   *
   * Use this prop if you need to render headers with a custom date library
   * instead of Intl.DateTimeFormat which has limited IE11 support.
   */
  renderHeader: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),

  /**
   * Set to false to hide current time indicator.
   */
  showNow: _propTypes["default"].bool
} : {};
CalendarMonthView.defaultProps = {
  locale: "en-US",
  now: (0, _dateString.toDateString)(new Date()),
  headerDateFormat: {
    weekday: "short"
  },
  distributedEventSpacingVertical: "small",
  showNow: true
};
var _default = CalendarMonthView;
exports["default"] = _default;